import { Injectable } from '@angular/core';
 
@Injectable({
  providedIn: 'root'
})
export class StateService {
  storage: Storage;
  constructor() {
    this.storage = window.sessionStorage;
  }

  getState(storageKey: string): any {
    const state = this.storage.getItem(storageKey);
    return state ? JSON.parse(state) : null;
  }

  setState(storageKey: any, state: any): void {
    this.storage.setItem(storageKey, JSON.stringify(state));
  }

  clearItem(key: any): void {
    this.storage.removeItem(key);
  }
}
